<template>
  <div id="video">
    <iframe
      width="560"
      height="315"
      src="https://www.youtube.com/embed/JBN_hjgR1KQ"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    >
    </iframe>
  </div>
</template>

<script>
import Video from '@/views/Peer/Video.vue';
export default {
  components: { Video },
  name: 'MainVideo',
};
</script>

<style lang="scss">
#video {
  width: 100%;
  display: inline-block;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>
